@if (goalDetails) {
  <div class="goal-details-container">
    <div class="back-to-overview">
      <a routerLink="/">
        <img src="/assets/images/icons/BackArrow.svg">
        Back to Overview
      </a>
    </div>
    <h1>{{labelText}}</h1>
    <app-goal-display [goal]="goalDetails.goal" [isNavigable]="false"></app-goal-display>
    @if (goalDetails) {
      <div class="sub-themes-panel">
        @for (subTheme of goalDetails.subThemes; track subTheme) {
          <div class="sub-theme">
            @if (subTheme.name) {
              <div class="name">{{subTheme.name}}</div>
            }
            @for (expandableMetric of subTheme.metrics; track expandableMetric; let i = $index) {
              <div class="metric"
                (click)="toggleExpandedState(expandableMetric)">
                <div class="header">
                  <div class="name-panel">
                    <div class="name {{'goal-background-' + goalId }}">
                      {{expandableMetric.metric.metric}}
                    </div>
                  </div>
                  <div class="chart-panel">
                    <div class="chart">
                      <app-metric-donut-chart [metric]="expandableMetric.metric" [goalId]="goalId"
                      [metricIndex]="expandableMetric.metric.metricId"></app-metric-donut-chart>
                    </div>
                  </div>
                  <div class="target-panel">
                    <div class="target">
                      {{expandableMetric.metric.targetValueDisplay}}
                      <span [innerHtml]="expandableMetric.metric.unit"></span>
                    </div>
                  </div>
                </div>
                @if (expandableMetric.isExpanded) {
                  <div class="body">
                    <div class="metric-progress-by-region-panel">
                      <h2>{{expandableMetric.metric.metric}} by region</h2>
                      <div class="description">
                        The regional targets shown are the sum of targets established after January 1, 2020. The
                        regional progress percentage is the sum of progress reported within the same time frame.
                      </div>
                      <div class="regions-chart-panel" [ngClass]="{'has-overages': true}">
                        <div class="chart-body">
                          @for (region of expandableMetric.metric.regions; track region) {
                            <div class="chart-item"
                              [ngClass]="{'has-overage': regionHasOverage(region)}">
                              <div class="region-name">
                                {{region.region}}
                              </div>
                              <div class="progress-percentage-container">
                                <div class="progress-percentage-panel"
                                  [ngStyle]="{'left': getProgressLeft(region)}">
                                  <div class="progress-percentage-panel-contents">
                                    <div class="progress-percentage">
                                      {{getProgressPercentage(region) + '%'}}
                                    </div>
                                    <div class="progress-percentage-mark"></div>
                                  </div>
                                </div>
                              </div>
                              <div class="bar">
                                <div class="target-series {{'goal-alt-background-' + goalId }}"></div>
                                <div class="progress-series {{'goal-background-' + goalId }}"
                                [ngStyle]="{'width.%': getProgressWidth(region)}"></div>
                              </div>
                              @if (regionHasOverage(region)) {
                                <div class="overage {{'goal-background-' + goalId }}"
                                ></div>
                              }
                              <div class="target">
                                {{region.regionsTargetValue | number: numberPipePrecision(expandableMetric.metric.floatingPointPrecision) }}&nbsp;
                                <span [innerHtml]="expandableMetric.metric.regionalDetailsShortUnitDisplay"></span>
                              </div>
                            </div>
                          }
                        </div>
                        <div class="legend-panel">
                          <div class="legend">
                            <div class="legend-item">
                              <div class="square-panel">
                                <div class="square {{'goal-background-' + goalId }}"></div>
                              </div>
                              <div class="description">Total Progress to Date</div>
                            </div>
                            <div class="legend-item">
                              <div class="square-panel">
                                <div class="square {{'goal-alt-background-' + goalId }}"></div>
                              </div>
                              <div class="description">Total Project Targets</div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="footnote">
                        ** Where a project touches down in multiple regions, progress will be attributed
                        to the lead region as represented in the Hub. Strategies from our global teams
                        are primarily tracked at the regional level. Progress shown includes project progress
                        dated on or after January 1, 2020.
                      </div>
                    </div>
                    <hr />
                    <div class="strategies-showing-recent-progress-panel">
                      <h2>Strategies showing recent progress</h2>
                      <div class="description">
                        The strategies listed below have been recently updated with new progress data.
                      </div>
                      <div class="strategies-list">
                        @for (strategy of expandableMetric.metric.recentStrategies; track strategy) {
                          <div class="strategy">
                            <a [routerLink]="'/portfolio/' + strategy.strategyProjectId"
                            class="name">{{strategy.strategy}}</a>
                            <div class="button-panel">
                              <button [routerLink]="'/portfolio/' + strategy.strategyProjectId">GO TO HUB
                              RECORD</button>
                            </div>
                          </div>
                        }
                      </div>
                      <div class="portfolio-link-panel">
                        <a href="javascript: void(0)" (click)="showAllStrategies(expandableMetric.metric)">Show all
                          Strategies for <span>{{expandableMetric.metric.metric}}</span></a>
                        </div>
                      </div>
                    </div>
                  }
                </div>
              }
            </div>
          }
        </div>
      }
    </div>
  }
